import React, {FC, Fragment, ReactNode} from "react";
import {Parallax, ParallaxBanner, ParallaxBannerLayer, ParallaxProvider} from "react-scroll-parallax";

interface IProps {
    children: ReactNode;
    backgroundAttachment?: string;
    backgroundImage?: string;
    isMobile: boolean
}

const ParallaxEffect:FC<IProps> = ({ backgroundAttachment, children, backgroundImage, isMobile }) => {
    if (backgroundAttachment === "fixed") {
        return <ParallaxProvider>
            <div style={{ position: "relative" }}>
                <ParallaxBanner style={{ aspectRatio: '2 / 1', position: "absolute", height: "100%" }}>
                    <ParallaxBannerLayer image={backgroundImage?.replace(/^url\((.*)\)$/, '$1')} speed={isMobile ? -20 : -35} />
                </ParallaxBanner>
                {children}
            </div>
        </ParallaxProvider>
    }
    return <Fragment children={children} />
}

export default ParallaxEffect;
